export default __webpack_public_path__ + "static/media/Tildes azules-1.9685172a.png";